// Click handlet to launch CMP layer 2 from links with .cmp-settings-toggle class
const toggleSettingsLinks = document.getElementsByClassName( 'cmp-settings-toggle' );
[ ...toggleSettingsLinks ].forEach( link => {
	link.addEventListener( 'click', e => {
		e.preventDefault();

		if ( global.__tcfapi ) {
			window.openUi( 'Level2' );
		} else if ( global.__uspapi ) {
			global.__uspapi.a.push( [ 'openSettings', null, () => {} ] );
		}
	}, false );
} );
